import React, { useState, useEffect, useMemo } from 'react';
import { CrudMasterDetailView, GridView, CrudContext, CompositeView, notification } from '@digital/ui';
import { getAllEsin204, Esin204, getAllRegistroEsin204ByEsin204Id, RegistroEsin204, postImportacaoRelatorioiIn204, consolidarExecutado, getExportarLinhaReclassificacao, getValidarExportarLinhaReclassificacao, creatRateioAutomativo, habilitarEdicao } from '@app/api/esin204';
import Importacao from './importacao';
import { getAllTipoExecutadoAnoMesOptions, Tipo } from '@app/api/status';

const mensagemErroExportaLinhaDeReclassificacao = "É necessário ter ao menos um registro Reclass marcado como Verdadeiro para exportar a planilha";
const Executado = () => {
    const [allEsin204, setAllEsin204] = useState(() => getAllEsin204);
    const [allTipoExecutadoAnoMesOptions, setAllTipoExecutadoAnoMesOptions] = useState<Tipo[]>();
    const [esin204From, setEsin204From] = useState<Esin204>();
    const [resultRegistroEsin204, setResultRegistroEsin204] = useState<RegistroEsin204[]>([]);
    const [hasFile, setHasFile] = useState(false);
    const [hasAtualizarTabelaResultado, sethasAtualizarTabelaResultado] = useState(false);

    useEffect(() => {
        getAllTipoExecutadoAnoMesOptions().then((data) => {
            setAllTipoExecutadoAnoMesOptions(data)
        })
    }, [esin204From]);

    const atualizarEsin204 = () => {
        setAllEsin204(() => Promise.resolve(undefined));
        setAllEsin204(() => getAllEsin204);
    }

    useMemo(async () => {
        if (esin204From && esin204From.id) {
            const result = await getAllRegistroEsin204ByEsin204Id(esin204From.id);
            if (result) {
                setResultRegistroEsin204(result);
            }
        }
    }, [esin204From, hasAtualizarTabelaResultado]);



    const handPostImportacaoRelatorioiIn204 = (values: Esin204) => {
        if (values.formData != undefined && values.formData != null)
            setHasFile(true);

        postImportacaoRelatorioiIn204(values, values.formData).then((data) => {
            if (data) {
                if (data.valid) {
                    if (data.alerMessage && data.alerMessage.length > 0) {
                        data.alerMessage.forEach(item => notification.warn(item.message));
                    }
                    sethasAtualizarTabelaResultado(!hasAtualizarTabelaResultado);
                    atualizarEsin204();
                }
            }
        });
    }

    const hasConsolidarExecutado = (esin204: Esin204) => {
        if (esin204) {
            consolidarExecutado(esin204.id).then((data) => {
                if (data) {
                    atualizarEsin204();
                    sethasAtualizarTabelaResultado(!hasAtualizarTabelaResultado);
                }
            });
        }
    }

    const exportarLinhaReclassificacao = (esin204: Esin204) => {
        if (esin204) {
            getValidarExportarLinhaReclassificacao(esin204.id).then((data) => {
                if (data === true) {
                    getExportarLinhaReclassificacao(esin204.id);
                } else {
                    notification.error(mensagemErroExportaLinhaDeReclassificacao);
                }
            })
        }
    }

    const hasCreatRateioAutomativo = (esin204: Esin204) => {
        if (esin204) {
            creatRateioAutomativo(esin204.id).then((data) => {
                atualizarEsin204();
                sethasAtualizarTabelaResultado(!hasAtualizarTabelaResultado);
            });
        }
    }

    const hasHabilitarEdicao = (esin204: Esin204) => {
        if (esin204) {
            habilitarEdicao(esin204.id).then((data) => {
                atualizarEsin204();
                sethasAtualizarTabelaResultado(!hasAtualizarTabelaResultado);
            });
        }
    }

    return (
        <CrudMasterDetailView
            getAllItems={allEsin204}
            filterPredicate={(item, value) =>
                item.ano.toString().startsWith(value)
            }
            titleExtractor={item =>
                item.ano.toString() + '/' + item.mes.toString()
            }
            detailTitleExtractor={
                item =>
                    item.ano.toString() + ' - ' + item.mes.toString() + ' - ' + item.processadoDescricao.toString() || '---'
            }
            descriptionExtractor={item => item.processadoDescricao.toString() || '---'} >
            <CrudContext.Consumer>
                {({ selectedItem }) => (
                    <CompositeView>
                        {true && selectedItem ? (
                            <GridView icon="industry-gears" id="geral" noform title="EXECUTADO">
                                <>
                                    {
                                        setEsin204From(selectedItem)
                                    }
                                    {selectedItem
                                        && esin204From
                                        && allTipoExecutadoAnoMesOptions ?
                                        (<Importacao
                                            esin204={esin204From}
                                            atualizarEsin204={atualizarEsin204}
                                            resultRegistroEsin204={resultRegistroEsin204}
                                            handPostImportacaoRelatorioiIn204={handPostImportacaoRelatorioiIn204}
                                            hasFile={hasFile}
                                            atualizarTabela={hasAtualizarTabelaResultado}
                                            allTipoExecutadoAnoMesOptions={allTipoExecutadoAnoMesOptions}
                                            hasConsolidarExecutado={hasConsolidarExecutado}
                                            hasExportarLinhaReclassificacao={exportarLinhaReclassificacao}
                                            hasCreatRateioAutomativo={hasCreatRateioAutomativo}
                                            hasHabilitarEdicao={hasHabilitarEdicao}
                                        />)
                                        : () => { <> </> }}
                                </>
                            </GridView>
                        ) : (
                                () => { }
                            )}
                    </CompositeView>
                )}
            </CrudContext.Consumer>
        </CrudMasterDetailView >
    );
};

export default Executado;
